import { QueryCache, QueryClient } from "@tanstack/react-query";

import { notifyCatch } from "@/ui/global-notification";

export type ErrorMetadata = {
  disableToastOnError: boolean;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.disableToastOnError) return;
      // only show toast errors on the first call that fetches the data,
      // and not on background (refetch) calls.
      if (query.state.data === undefined && error instanceof Error)
        notifyCatch(error);
    },
  }),
});
